/** @file checkAttachmentRefs: the host nodes an attachment names (`when`, `driver`, `nodeMap` values) exist. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { Attachment, Puppet } from '@zilo/pose3d-format/types/puppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** Throws `NOT_FOUND` at `<path>/when/hostNode`, `<path>/when/parent`, `<path>/driver` or `<path>/nodeMap/<k>`. */
export function checkAttachmentRefs(host: Pick<Puppet, 'nodes'>, attachment: Attachment, path: string): void {
  const refs: [string, string][] = Object.entries(attachment.nodeMap).map(([k, v]) => [`${path}/nodeMap/${k}`, v]);
  if (attachment.when !== undefined) refs.push([`${path}/when/hostNode`, attachment.when.hostNode], [`${path}/when/parent`, attachment.when.parent]);
  if (attachment.driver !== undefined) refs.push([`${path}/driver`, attachment.driver]);
  for (const [at, node] of refs) {
    if (!Object.hasOwn(host.nodes, node)) throwError(ERROR_CODES.NOT_FOUND, { node }, { path: at, hint: 'a node of the host puppet' });
  }
}
